import {Component, Input} from '@angular/core';
import {PatientDataProvider} from '../../../providers/patient-data/patient-data';

@Component({
  selector: 'page-status',
  templateUrl: 'status.html',
  styleUrls: ['./status.scss']
})
export class StatusPage {
  @Input() showHeader = true;

  constructor(public patientDataProvider: PatientDataProvider) {

  }

}
